module.exports = __webpack_public_path__ + "img/aptitude31.b760dd25.jpg";